import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { ANALYTICS_EVENTS, useEvent, useTrendsStore } from '../../common'
import { LineChart } from '../../common/components/charts/LineChart'

import { TRENDS_ANALYTICS_METADATA } from '../constants/TrendsWidget'
interface CategoryDetailChartProps {
  chartColor: string
  chartLabel: string
}
const CategoryDetailChart = observer(({ chartLabel, chartColor }: CategoryDetailChartProps) => {
  const { onEvent } = useEvent()
  const {
    categoryDetailsChartData: { monthlyAmounts, tooltipLabels },
  } = useTrendsStore()

  const handleItemClick = () => {
    onEvent(ANALYTICS_EVENTS.TRENDS_CLICK_CHART, TRENDS_ANALYTICS_METADATA)
  }

  return (
    <Stack sx={{ pt: 12, width: '100%' }}>
      <LineChart
        baseline="min"
        colors={[chartColor]}
        curveType="bump"
        customTooltipLabels={tooltipLabels}
        datasets={[monthlyAmounts]}
        height={265}
        labels={[chartLabel]}
        markStyles={() => ({
          stroke: chartColor,
        })}
        onItemClick={handleItemClick}
        showArea={true}
        showAverage={true}
        showAxisHighlight={true}
        showLegend={true}
        showTooltip={true}
        showXAxis={true}
        showXAxisTicks={true}
        showYAxis={true}
        showYAxisTicks={true}
        useCustomMark={true}
        valueFormatterString="0,0"
      />
    </Stack>
  )
})
export default CategoryDetailChart
